import { defineStore } from 'pinia';

export const useErrorStore = defineStore('error', {
    state: () => ({
        isNotFound: false,
        isUnauthorized: false,
    }),
    actions: {
        setNotFound(status) {
            this.isNotFound = status;
        },
        setUnauthorized(status) {
            this.isUnauthorized = status;
        },
        reset() {
            this.isNotFound = false;
            this.isUnauthorized = false;
        }
    }
});